import { BaseService } from "./baseService";

// Contact form types
export interface ContactFormData {
  name: string;
  email: string;
  subject: string;
  category: 'general' | 'support' | 'business' | 'investor' | 'media' | 'feedback';
  message: string;
}

export interface ContactSubmissionResponse {
  success: boolean;
  message: string;
  id?: string;
  errors?: Array<{
    field: string;
    message: string;
  }>;
  retryAfter?: number;
}

export class ContactService extends BaseService {
  /**
   * Submit a contact form
   */
  static async submitContact(formData: ContactFormData): Promise<ContactSubmissionResponse> {
    try {
      const response = await this.post("/contact", formData);

      // Handle 400 responses specially since they contain validation errors
      if (response.status === 400) {
        const errorData = await response.json();
        return errorData; // Return the structured validation response directly
      }

      // Handle other error status codes
      if (!response.ok) {
        if (response.status === 429) {
          return {
            success: false,
            message: "Too many requests. Please try again later.",
            retryAfter: 3600
          };
        }

        return {
          success: false,
          message: "There was an error sending your message. Please try again later."
        };
      }
      
      // Success case - use normal response handling
      return await this.handleResponse<ContactSubmissionResponse>(response);
    } catch (error) {
      console.error("Error submitting contact form:", error);

      // Generic error response for network/other errors
      return {
        success: false,
        message: "There was an error sending your message. Please try again later."
      };
    }
  }
}